import { useContext, useEffect, useState } from 'react';

import * as Sentry from '@sentry/react';
import { CurrentuserContext } from '@uplift/contexts';
import { CurrentUser } from '@uplift/api';
import { UserRole } from '@uplift/types';

declare global {
  interface Window {
    dataLayer: any[];
    analytics: any;
  }
}

const googleIdentifyUser = (me: CurrentUser | null) => {
  if (typeof window.dataLayer !== 'undefined') {
    if (me?.id) {
      window.dataLayer.push({
        userId: me.id,
      });
      return true;
    }
  }
};

type identData = {
  status: CurrentUser['status'];
  role: CurrentUser['role'];
  '$braze_external_id': string;
  medicalRole?: CurrentUser['medicalRole'];
  fullTime?: CurrentUser['fullTime'];
};

const freshpaintIdentifyUser = (me: CurrentUser | null) => {
  if (typeof window.freshpaint === 'undefined') {
    return false;
  }

  if (!me?.id) {
    return false;
  }

  const ident: identData = {
    status: me.status,
    role: me.role,
    '$braze_external_id': me.id,
  };

  if (me.role === UserRole.provider) {
    ident.medicalRole = me.medicalRole;
    ident.fullTime = me.fullTime;
  }

  try {
    window.freshpaint.identify(me.id, ident);
  } catch (error) {
    console.error('Freshpaint identify error:', error);
    return false;
  }

  return true;
};

const sentryIdentifyUser = (me: CurrentUser | null) => {
  if (me?.id) {
    Sentry.setUser({ id: me.id });
  }
};

export const useDispatchUserId = () => {
  const [ isComplete, setIsComplete ] = useState(false);
  const me = useContext(CurrentuserContext);

  useEffect(() => {
    if (!isComplete) {
      setIsComplete(!!googleIdentifyUser(me));
      setIsComplete(freshpaintIdentifyUser(me));
      sentryIdentifyUser(me);
    }
  }, [ isComplete, setIsComplete, me ]);
};
